import { ReactNode } from 'react'
import ReactQuill from 'react-quill'
import { Typography } from '@mui/material'
import 'react-quill/dist/quill.snow.css'

import { useStyles } from './styles'

interface IProps {
  value: string
  handleChange: (value: string, _delta: any, source: string) => void
  label?: ReactNode
  error?: string
  isDisabled?: boolean
}

export const TextEditor = ({ value, handleChange, label, error, isDisabled }: IProps) => {
  const classes = useStyles()

  const modules = {
    toolbar: [
      [
        // { font: [] },
        { size: [] },
      ],
      [
        'bold',
        'italic',
        'underline',
        // , 'strike'
      ],
      // [{ color: [] }, { background: [] }],
      // [{ script: 'super' }, { script: 'sub' }],
      [
        { header: '1' },
        { header: '2' },
        // 'blockquote', 'code-block'
      ],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['direction', { align: [] }],
      [
        'link',
        'image',
        'video',
        // 'formula'
      ],
      // ['clean'],
    ],
    clipboard: {
      matchVisual: false,
    },
  }

  return (
    <div className={classes.container}>
      <Typography className={classes.label}>{label}</Typography>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        className={classes.root}
        modules={modules}
      />
      {error && (
        <Typography className={classes.errText} color="error">
          {error}&nbsp;
        </Typography>
      )}
    </div>
  )
}
